import { getListWithdrawRequest, getListPayout, getWithdrawHistory, setApproveReject, setPayoutPayment, setPayoutMarkPay, setPayoutSchedule, getScheduledPayoutHistory, getPendingPayoutReview, setPayoutReview, getWiseBalance } from '@/services/finance';

const getters = {
  listWithdrawRequest: state => state.listWithdrawRequest,
  listPayout: state => state.listPayout,
  listWithdrawHistory: state => state.listWithdrawHistory,
  scheduledPayoutHistory: state => state.scheduledPayoutHistory,
  pendingPayoutReview: state => state.pendingPayoutReview,
  wiseBalance: state => state.wiseBalance,
  per_page: state => state.per_page,
};

const actions = {
  async requestListWithdrawRequest({ commit, rootGetters }, filter) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      const response = await getListWithdrawRequest({ tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] }, filter);
      commit('SET_LIST_WITHDRAW_REQUEST', response);
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
  async requestListPayout({ commit, rootGetters }, filter) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      const response = await getListPayout({ tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] }, filter);
      commit('SET_LIST_PAYOUT', response);
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
  async requestListWithdrawHistory({ commit, rootGetters }, filter) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      const response = await getWithdrawHistory({ tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] }, filter);
      commit('SET_LIST_WITHDRAW_HISTORY', response);
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
  async requestApproveReject({ commit, dispatch, rootGetters }, { data, filter }) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      await setApproveReject({ tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] }, data);
      dispatch('requestListWithdrawRequest', filter);
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
      throw err;
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
  async requestMakePayment({ commit, dispatch, rootGetters }, { data, filter }) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      await setPayoutPayment({ tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] }, data);
      dispatch('requestListPayout', filter);
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
      throw err;
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
  async requestMarkPayout({ commit, dispatch, rootGetters }, { data, filter }) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      await setPayoutMarkPay({ tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] }, data);
      dispatch('requestListPayout', filter);
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
      throw err;
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
  async requestSchedulePayout({ commit, dispatch, rootGetters }, { data, filter }) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      await setPayoutSchedule({ tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] }, data);
      dispatch('requestListPayout', filter);
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
      throw err;
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
  async requestScheduledPayoutHistory({ commit, rootGetters }) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      const response = await getScheduledPayoutHistory({ tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] });
      commit('SET_SCHEDULED_PAYOUT_HISTORY', response);
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
  async requestPendingPayoutReview({ commit, rootGetters }) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      const response = await getPendingPayoutReview({ tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] });
      commit('SET_PENDING_PAYOUT_REVIEW', response);
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
  async requestPayoutReview({ commit, dispatch, rootGetters }, { data, filter }) {
    // approving executes the batch transfers on the backend and the result is
    // reported through email, so the approval runs without the loading overlay
    const shouldToggleLoading = data.decision !== 'approved';
    if (shouldToggleLoading) {
      commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    }
    try {
      await setPayoutReview({ tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] }, data);
      await Promise.all([
        dispatch('requestListPayout', filter),
        dispatch('requestScheduledPayoutHistory'),
        dispatch('requestPendingPayoutReview'),
      ]);
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
      throw err;
    } finally {
      if (shouldToggleLoading) {
        commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
      }
    }
  },
  async requestWiseBalance({ commit, rootGetters }) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      const response = await getWiseBalance({ tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] });
      commit('SET_WISE_BALANCE', response);
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
};

const mutations = {
  SET_LIST_WITHDRAW_REQUEST(state, listWithdrawRequest) {
    state.listWithdrawRequest = listWithdrawRequest;
  },
  SET_LIST_PAYOUT(state, listPayout) {
    state.listPayout = listPayout;
  },
  SET_LIST_WITHDRAW_HISTORY(state, listWithdrawHistory) {
    state.listWithdrawHistory = listWithdrawHistory;
  },
  SET_SCHEDULED_PAYOUT_HISTORY(state, scheduledPayoutHistory) {
    state.scheduledPayoutHistory = scheduledPayoutHistory;
  },
  SET_PENDING_PAYOUT_REVIEW(state, pendingPayoutReview) {
    state.pendingPayoutReview = pendingPayoutReview;
  },
  SET_WISE_BALANCE(state, wiseBalance) {
    state.wiseBalance = wiseBalance;
  },
};

export default {
  namespaced: true,
  state: {
    listWithdrawRequest: [],
    listPayout: [],
    listWithdrawHistory: [],
    scheduledPayoutHistory: [],
    pendingPayoutReview: null,
    wiseBalance: null,
    per_page: 50,
  },
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/stores/Finance/index.js